import { render, staticRenderFns } from "./apply-recordsystem.vue?vue&type=template&id=6754ebdc&scoped=true&"
import script from "./apply-recordsystem.vue?vue&type=script&lang=js&"
export * from "./apply-recordsystem.vue?vue&type=script&lang=js&"
import style0 from "./apply-recordsystem.vue?vue&type=style&index=0&id=6754ebdc&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6754ebdc",
  null
  
)

export default component.exports